import { downloadAllAsZip } from "services";
import { useAsyncAction } from "../../../../hoc/useAsyncAction";
import { useCallback, useMemo } from "react";
import { Button } from "../../../../shadcn/components/ui/button";
import { ButtonStatesInterface } from "./PropertyDocumentViewListItem";

interface PDDownloadAllCtaButtonPropsInterface {
  files: any[];
  zipFileName: string;
  onDownloadFailed?: () => void;
  onDownloadSuccess?: () => void;
  onDownloading?: () => void | boolean;
  withAuth?: (callback: () => void) => any;
  buttonStates?: ButtonStatesInterface;
}

export const PDDownloadAllCtaButton: React.FC<
  PDDownloadAllCtaButtonPropsInterface
> = ({
  files,
  zipFileName = "",
  onDownloadFailed = () => {},
  onDownloadSuccess = () => {},
  onDownloading = () => {},
  withAuth = () => {},
  buttonStates = { processing: false, error: false, success: false },
}) => {
  const {
    execute: handleDownloadAllDocumentsAsZipFile,
    isLoading,
    isSuccess,
    isError,
  } = useAsyncAction(
    async ({ files, zipFileName }: { files: any[]; zipFileName: string }) => {
      const finalZipName = zipFileName || Date.now().toString();
      await downloadAllAsZip(files, finalZipName);

      return true;
    },
  );

  const handleClick = useCallback(async () => {
    onDownloading();

    const payload = { files, zipFileName };

    handleDownloadAllDocumentsAsZipFile(payload, {
      onSuccess: () => {
        onDownloadSuccess();
      },
      onError: () => {
        onDownloadFailed();
      },
    });
  }, [
    onDownloading,
    handleDownloadAllDocumentsAsZipFile,
    files,
    zipFileName,
    onDownloadSuccess,
    onDownloadFailed,
  ]);

  const finalButtonStates = useMemo(() => {
    return {
      processing: isLoading || buttonStates.processing,
      success: isSuccess || buttonStates.success,
      error: isError || buttonStates.error,
    };
  }, [isLoading, isSuccess, isError, buttonStates]);

  return (
    <Button
      className="bg-brand-primaryAction hover:bg-brand-primaryActionHover"
      onClick={() => withAuth(handleClick)()}
      disabled={finalButtonStates.processing || finalButtonStates.success}
    >
      {finalButtonStates.processing && "Downloading..."}
      {!finalButtonStates.processing && "Download All"}

      {finalButtonStates.success && " ✔"}
      {finalButtonStates.error && " ❌"}
    </Button>
  );
};
